import axios from "axios";
import store from "@/store";

const apiClient = axios.create({
    baseURL:
        process.env.VUE_APP_API_ENDPOINT || "https://cb2.caas.be/api_caas/web",
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

const rpc = async (rpcName, params) => {
    // inject webSessionId into params
    params = params || {};
    if (store.getters["session/sessionActive"]) {
        params.webSessionId = store.getters["session/webSessionId"];
    }
    // go!
    const oBody = { request: { rpcName, params } };
    const response = await apiClient.post("/rpc", oBody);
    return response;
};

const sdo = async (sdoName, params) => {
    // inject webSessionId into params
    params = params || {};
    if (store.getters["session/sessionActive"]) {
        params.webSessionId = store.getters["session/webSessionId"];
    }
    // go!
    const oBody = { request: { sdoName, params } };
    const response = await apiClient.post("/sdo", oBody);
    return response;
};

export default {
    rpc,
    sdo,
};
